import { render } from "./consultation_service.vue?vue&type=template&id=03df842e&scoped=true"
import script from "./consultation_service.vue?vue&type=script&lang=js"
export * from "./consultation_service.vue?vue&type=script&lang=js"

import "./consultation_service.vue?vue&type=style&index=0&id=03df842e&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03df842e"]])

export default __exports__